import React from 'react'
import { IIcon } from './Icon.interface'
import { IconTestIds } from './iconTestIds'

export const MoreIcon = ({ classes }: IIcon) => (
  <svg
    data-testid={IconTestIds.More}
    className={classes}
    focusable="false"
    aria-hidden="true"
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4L4 1L7 4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
